// extracted by mini-css-extract-plugin
export var completionBody = "_hz-2";
export var completionCard = "_hz-0";
export var completionFooter = "_hz-3";
export var completionTitle = "_hz-1";